<template>
  <div>
    <page-header title="Events" class="page-banner"></page-header>
    <content-loader v-if="$apollo.loading" title="Jobs" />
    <div class="container" v-else>
      <div class="event-container">
        <div
          class="row mb-4 align-items-sm-center d-flex justify-content-between"
        >
          <div class="col-sm-6">
            <h2 class="cs-textstyle-page-subtitle">Upcoming events</h2>
          </div>
          <div class="events-toggle">
            <cs-toggle
              v-model="officialEvents"
              label-unchecked="All events"
              label-checked="Official events only"
            ></cs-toggle>
          </div>
        </div>

        <div class="event-list">
          <cs-event-card
            v-for="event in events"
            :key="event.id"
            :title="event.title"
            :picture="event.picture"
            :tags="makeTag(event)"
            :datetime="event.date_time"
            :location="event.city.name || 'Online'"
            :organiser="event.group.name"
            picture-position="top"
            layout="small"
            hide-buttons
            @click="onOpenEventDetails(event)"
          ></cs-event-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listEvents from '@/newgql/ListUpcomingEvents.gql';
import PageHeader from '@/components/global/PageHeader';
import EventsCard from '@/components/events/EventsCard';
import ContentLoader from '@/components/global/ContentLoader';
import FilterByCity from '@/components/global/FilterByCity';
import FilterByDate from '@/components/events/FilterByDate';

const PER_PAGE = 12;

export default {
  name: 'event-list',

  components: {
    PageHeader,
    ContentLoader,
    FilterByCity,
    FilterByDate,
    EventsCard
  },

  apollo: {
    event: {
      query: listEvents,
      loadingKey: 'loading',
      watchQuery: { fetchPolicy: 'network-only' },
      fetchPolicy: 'network-only',
      variables() {
        return {
          today: this.$moment()
        };
      }
    }
  },

  data() {
    return {
      filters: {
        city: '',
        date: '',
        whereCondition: {}
      },
      loading: 0,
      offset: 0,
      page: 0,
      officialEvents: true
    };
  },

  computed: {
    events() {
      if (this.event && this.officialEvents === true) {
        return this.event.filter(evnt => {
          return evnt.group.type === 'official';
        });
      }
      return this.event;
    }
  },

  methods: {
    async fetchData() {
      await this.$apollo.queries.events.fetchMore({
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }
          return Object.assign({}, previousResult, {
            events: [...previousResult.events, ...fetchMoreResult.events]
          });
        }
      });
    },
    makeTag(event) {
      let tags = [];
      let tag = event.group.type + ' event';
      tags.push(tag);
      return tags;
    },
    filterEvents() {
      const currentDate = this.$moment();
      const startWeek = currentDate
        .clone()
        .startOf('isoWeek')
        .format('YYYY-MM-DD');
      const endWeek = currentDate
        .clone()
        .endOf('isoWeek')
        .add(1, 'days')
        .format('YYYY-MM-DD');
      const startMonth = currentDate
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD');
      const endMonth = currentDate
        .clone()
        .endOf('month')
        .add(1, 'days')
        .format('YYYY-MM-DD');

      this.page = 0;
      this.offset = 0;
      this.filters.whereCondition = {};

      if (this.filters.city) {
        this.filters.whereCondition.cityId = { _eq: this.filters.city.id };
      }

      if (this.filters.date) {
        switch (this.filters.date) {
          case 'today':
            let today = currentDate.format('YYYY-MM-DD');
            let tomo = currentDate.add(1, 'days').format('YYYY-MM-DD');
            this.filters.whereCondition._and = {
              start: { _gte: today, _lt: tomo }
            };
            break;
          case 'this_week':
            this.filters.whereCondition._and = {
              start: { _gte: startWeek, _lt: endWeek }
            };
            break;
          case 'this_month':
            this.filters.whereCondition._and = {
              start: { _gte: startMonth, _lt: endMonth }
            };
            break;
        }
      }
    },
    onOpenEventDetails(event) {
      this.$router.push({ name: 'EventDetail', params: { id: event.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  font-weight: 700;

  @include media-breakpoint-up(md) {
    font-size: 28px;
  }
}

.event-container {
  padding: 0px 0 50px;
}

.event-list {
  display: grid;
  grid-gap: 1rem;
  @include media-breakpoint-up(md) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.event-list .cs-event-card {
  margin: 0;
  cursor: pointer;
}
/deep/ .cs-card__info .cs-event-card__title {
  margin-top: 0;
}

.events-toggle {
  padding-right: 0.85rem;
  padding-left: 0.85rem;
}
</style>
